// eslint-disable-next-line
import { injectable } from "inversify";
import { IReturnScoreSetting, ISetting } from "../../models/User";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import {WithOld} from "../../stores/types";

@injectable()
class SettingsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async saveStoreSettings(settings: WithOld<ISetting>): Promise<ISetting> {
        const res = await this.httpService.put<IApiResponse<ISetting>>('/rms-api/user/settings/store', settings);
        return res.payload;
    }

    public async saveReturnScoreSettings(settings: IReturnScoreSetting): Promise<IReturnScoreSetting> {
        const res = await this.httpService.put<IApiResponse<IReturnScoreSetting>>('/rms-api/user/settings/return-score', settings);
        return res.payload;
    }
}

export default SettingsService;
